<div class="c-tabs" [ngClass]="customClass">
  <button
    *ngFor="let interval of intervals"
    [disabled]="disabled"
    (click)="selectedInterval(interval)"
    [ngClass]="[
      shownIntervalsSet.has(interval) ? 'd-inline' : alwaysHideIntervals ? 'd-none' : 'd-none d-xxl-inline',
      currentInterval === interval ? 'c-tabs__item--selected' : ''
    ]"
    class="c-tabs__item"
  >
    {{ ranges[interval].title }}
  </button>
</div>
<p500-ui-dropdown
  *ngIf="shownIntervalsSet.size < intervals.length"
  [position]="dateRangeDropdownPosition"
  class="c-tabs c-dropdown c-dropdown--list"
>
  <ng-template p500UIDropdownHeader let-isOpen="isOpen" let-toggle="toggle">
    <button
      p500-ui-circled-button
      color="primary"
      size="large"
      [ngClass]="[alwaysHideIntervals ? '' : 'd-xxl-none']"
      class="c-button c-button--filters d-flex"
      (click)="toggle()"
    >
      <p500-ui-icon name="other-menu" size="16px"></p500-ui-icon>
    </button>
  </ng-template>
  <ng-template p500UIDropdownBody>
    <ng-container *ngFor="let interval of intervals">
      <div
        p500UIDropdownItem
        *ngIf="!shownIntervalsSet.has(interval)"
        class="c-dropdown__item"
        (click)="!disabled && selectedInterval(interval)"
      >
        <a
          p500-ui-button
          [disabled]="disabled"
          [transparent]="true"
          class="c-dropdown__item-button"
          [color]="currentInterval === interval ? 'primary' : 'secondary'"
        >
          {{ ranges[interval].title }}
        </a>
      </div>
    </ng-container>
  </ng-template>
</p500-ui-dropdown>
